import { MUTATION_NAME } from "@/static/global-variables";
import services from "@/services";
import store from "@/store";

function _getInitialPromiseState() {
  return {
    promise: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false
  };
}

class NitroDataCache {
  constructor() {
    this.globalObjects = _getInitialPromiseState();
    this.describeObjectMap = new Map();
    this.describeObjectsMap = new Map();
    this.metaObjectMap = new Map();
  }

  fetchAvailableTables() {
    const nitroDataCache = store.getters.nitroDataCache;
    if (nitroDataCache) {
      return Promise.resolve(nitroDataCache);
    }
    if (this.globalObjects.isPending) {
      return this.globalObjects.promise;
    }
    this.globalObjects.isPending = true;
    this.globalObjects.promise = services.fetchAvailableTables();
    this.globalObjects.promise.then(
      res => {
        this.globalObjects.isFulfilled = true;
        this.globalObjects.isPending = false;
        store.dispatch(MUTATION_NAME.SET_NITRO_DATA_CACHE, res);
      },
      e => {
        console.error(e);
        this.globalObjects.isRejected = true;
        this.globalObjects.isPending = false;
      }
    );
    return this.globalObjects.promise;
  }

  findColumns(nitroDataCache, tableName) {
    let output = [];
    const target = nitroDataCache.find(t => {
      return t.name === tableName;
    });
    if (target) {
      output = target.columns;
    }
    return output;
  }

  getColumnsFromTable(tableName) {
    const nitroDataCache = store.getters.nitroDataCache;
    if (nitroDataCache) {
      return Promise.resolve(this.findColumns(nitroDataCache, tableName));
    }

    return this.fetchAvailableTables().then(
      res => {
        return this.findColumns(res, tableName);
      },
      () => {
        console.error("Failed to retrieve nitro data");
        return [];
      }
    );
  }
}

export default new NitroDataCache();
